var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEngaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 29C26.866 29 30 25.866 30 22C30 18.134 26.866 15 23 15C19.134 15 16 18.134 16 22C16 25.866 19.134 29 23 29Z",
    stroke: "#66B929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18V22",
    stroke: "#66B929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22L26 21",
    stroke: "#66B929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4996 15.5C20.7996 14.7 20.9996 13.9 20.9996 13C20.9996 11.9 21.8996 11 22.9996 11V8.70003C22.9996 5.90003 20.8996 3.30003 18.0996 3.00003C16.0996 2.80003 14.2996 3.60003 13.1996 5.10003C12.3996 4.90003 11.5996 5.00003 10.5996 5.70003C9.59961 6.40003 8.99961 7.70003 8.99961 9.00003V10V11.5V12.8C8.99961 15 10.1996 17.1 11.9996 18.2C11.9996 20.5 10.3996 22.4 8.19961 23C5.59961 23.7 3.69961 25.8 3.09961 28.4C3.09961 28.7 3.29961 29 3.69961 29H22.9996",
    stroke: "#66B929",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngaging);
export default __webpack_public_path__ + "static/media/engaging.4a95a1522b811aca34fdb58ba33ec9fe.svg";
export { ForwardRef as ReactComponent };